const topics = [
  { name: '顶流塌房', heat: '236.8万', trending: true },
  { name: '网红翻车', heat: '189.2万', trending: true },
  { name: '综艺内幕', heat: '156.4万', trending: false },
  { name: '明星恋情', heat: '142.1万', trending: true },
  { name: '剧组八卦', heat: '128.7万', trending: false },
  { name: '直播翻车', heat: '115.3万', trending: true },
  { name: '抄袭争议', heat: '98.6万', trending: false },
  { name: '合约纠纷', heat: '87.4万', trending: true },
  { name: '带货打假', heat: '76.2万', trending: false },
  { name: '私生活曝光', heat: '68.9万', trending: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            热门话题标签
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            大家都在搜的吃瓜关键词
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#cards"
              className="group relative inline-flex items-center gap-2 px-4 py-2.5 md:px-5 md:py-3 rounded-full border border-background-200/70 bg-background-50 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer no-underline"
            >
              {topic.trending && (
                <span className="absolute -top-1.5 -right-1.5 w-4 h-4 bg-accent-500 rounded-full flex items-center justify-center">
                  <i className="ri-arrow-up-line text-[8px] text-background-50"></i>
                </span>
              )}
              <span className="text-sm md:text-base text-foreground-700 group-hover:text-primary-600 font-medium transition-colors">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-400">{topic.heat}</span>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="#cards"
            className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer"
          >
            查看更多话题
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}